"use client";

import { useEffect } from "react";

export default function ScriptInjector() {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.dataset.cfasync = "false";
    script.dataset.clocid = "2038542";
    script.src = "//nappyonsetstiffness.com/on.js";

    const target = [document.documentElement, document.body]
      .filter(Boolean)
      .pop();
    target?.appendChild(script);
  }, []);

  return null;
}
